import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Money} from 'yougile-model'

export const MoneyVal = (
  props: {amount: Money} & React.HTMLProps<HTMLElement>
) => {
  const {amount, ...domProps} = props
  if (!amount?.currency) {
    return <span {...domProps} />
  }
  switch (amount.currency) {
    case 'RUB':
      return (
        <span {...domProps}>
          {amount.amount} {Lang.msg.rub}
        </span>
      )
    default:
      return <span {...domProps} />
  }
}
